export const SUBSCRIPTION_PLANS = {
  FREE: { id: 'free', name: 'Free', price: 0, maxLocations: 1 },
  BASIC: { id: 'basic', name: 'Basic', price: 29, maxLocations: 1 },
  PRO: { id: 'pro', name: 'Pro', price: 99, maxLocations: 3 },
  BUSINESS: { id: 'business', name: 'Business', price: 299, maxLocations: 100 }
};

// Google OAuth is handled by backend, these are kept for reference
export const GOOGLE_CONFIG = {
  SCOPE: 'https://www.googleapis.com/auth/business.manage',
  RESPONSE_TYPE: 'code',
  ACCESS_TYPE: 'offline',
  PROMPT: 'consent'
};

export const API_ENDPOINTS = {
  AUTH: {
    GOOGLE_CALLBACK: '/auth/google/callback',
    LOGOUT: '/auth/logout',
    REFRESH_TOKEN: '/auth/refresh',
    USER_INFO: '/auth/user'
  },
  LOCATIONS: {
    LIST: '/locations',
    SELECT: '/locations/select',
    REMOVE: '/locations/remove'
  },
  REVIEWS: {
    LIST: '/reviews',
    GENERATE_REPLY: '/reviews/generate-reply',
    POST_REPLY: '/reviews/post-reply',
    POST_ALL: '/reviews/post-all'
  },
  DEMO: {
    REVIEWS: '/demo/reviews',
    GENERATE_REPLY: '/demo/generate-reply',
    POST_REPLY: '/demo/post-reply',
    LOCATIONS: '/demo/locations',
    USER: '/demo/user'
  }
};

export const REVIEW_STATUS = {
  PENDING: 'pending',
  REPLY_GENERATED: 'generated',
  POSTING: 'posting',
  POSTED: 'posted',
  FAILED: 'failed'
};

export const TOAST_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
};

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_DATA: 'user_data'
};

export const ERROR_MESSAGES = {
  GENERIC: 'Something went wrong. Please try again.',
  NETWORK: 'Network error. Please check your connection.',
  UNAUTHORIZED: 'Please log in to continue.',
  LOCATION_LIMIT_REACHED: 'Location limit reached. Please upgrade your plan.'
};

export const SUCCESS_MESSAGES = {
  LOGIN_SUCCESS: 'Successfully logged in!',
  LOCATION_ADDED: 'Location added successfully!',
  REPLY_POSTED: 'Reply posted successfully!'
};
